import swal from "sweetalert2";
import axios from "axios";

export default {
  methods: {
    enableMarket: async function(market, themeDark) {
      await this.$store.dispatch("markets/toggleMarket", {
        exchange: market.exchange,
        baseCurrency: market.base_currency,
        name: market.name,
        enabled: true
      });
    },
    disableMarket: async function(market, themeDark) {
      await this.$store.dispatch("markets/toggleMarket", {
        exchange: market.exchange,
        baseCurrency: market.base_currency,
        name: market.name,
        enabled: false
      });
    },
    getAccumulated: async function(market) {
      try {
        const response = await axios.get(
          "/api/v1/markets/" + market.name + "/accumulated"
        );

        return response.data.accumulated;
      } catch (error) {
        // fallback to zero to continue flow
        return 0;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/mixins/marketToggler.js